/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Guedder API
 * Contrato oficial da API v3 do Guedder (API-First).
 *
 * ## Modelo de resposta
 *
 * A v3 NÃO usa envelope. O status HTTP 2xx já comunica sucesso e o cliente
 * gerado é uma sealed-union por status-code. Sem `success`/`code`/`message` de
 * cerimônia. Respostas de objeto único retornam o tipo de domínio diretamente:
 * ```json
 * // 200 GET /api/v3/eventos/{eventoId}  → DadosBasicosEventoDto
 * { "id": "...", "nome": "..." }
 * ```
 *
 * ## Paginação
 *
 * TODA resposta de coleção usa um único shape canônico `Paged<T>`:
 * ```json
 * // 200 GET /api/v3/eventos  → Paged<DadosBasicosEventoDto>
 * { "content": [ { "id": "...", "nome": "..." } ], "page": { PageInfo } }
 * ```
 * `PageInfo` é offset-based, compatível com Spring Data `Page<T>`. Coleções
 * bounded (categorias, carrossel de destaque, devices, line-up) retornam uma
 * página única; params reais (`page`/`size`/`sort`) podem ser adicionados depois
 * sem quebrar o contrato (adição não-breaking).
 *
 * ## Erros
 *
 * Erro tem um único modelo: RFC 7807 (`ProblemDetail`), gerado nativamente pelo
 * Spring 6+. Validação de campo vem em `errors[]` dentro do próprio ProblemDetail.
 * ```json
 * { "type": "...", "title": "Not Found", "status": 404, "detail": "..." }
 * ```
 *
 * ## Convenções v3.1
 *
 * A v3.1 consolida as convenções de nomeação de recursos:
 * - **Sem sufixo `/publico`**: endpoints públicos não carregam mais o sufixo
 *   `/publico` no path; a ausência de `security` já comunica que são abertos.
 * - **Recursos plurais em kebab-case**: coleções usam nomes plurais
 *   (`/eventos`, `/ingressos`, `/compras`, `/cotacoes`) e paths compostos usam
 *   kebab-case (`/notification-tokens`, `/categorias-evento`,
 *   `/transferencias-pendentes`, `/wallet-config`).
 * - **Sub-recursos aninhados sob `/eventos`**: atrações, lotes, parâmetros de
 *   venda, visualizações e ingressos de check-in são modelados como
 *   sub-recursos de `/eventos/{eventoId}/...`.
 * - **Dois enums distintos para ingresso**: `StatusPagamentoIngresso` (estado
 *   de pagamento) e `CicloDeVidaIngresso` (eixo temporal: ativo/encerrado)
 *   deixam de ser misturados em um único enum. A custódia do ingresso
 *   (transferência em curso) é um terceiro eixo, servido pelo recurso
 *   `/transferencias-pendentes` — ver ADR-0016.
 *
 * ## Caixa dos enums
 *
 * Todo enum desta API é aceito em **qualquer caixa** na entrada — em query
 * params, path params e corpo JSON. `?cicloDeVida=ativo`, `Ativo` e `ATIVO`
 * são equivalentes.
 *
 * Isto é uma garantia do contrato, não um detalhe de implementação: existe
 * para que URLs compartilháveis e chamadas escritas à mão (curl, Postman)
 * não precisem carregar o valor em maiúsculo, que é desconfortável de ler e
 * digitar.
 *
 * A **saída** continua sempre no valor canônico em MAIÚSCULO. Clientes devem
 * comparar respostas contra o valor canônico, nunca assumir a caixa que
 * enviaram.
 *
 * ## Datas e fuso horário
 *
 * Datas têm **dois tipos distintos** neste contrato (ADR-0009), hoje
 * confundidos sob o mesmo `format: date-time`:
 *
 * - **Instante de auditoria** — `dataCriacao`, `dataCompra`, `dataCheckin`,
 *   `checkIn`, `realizadoEm`, `ProblemDetail.timestamp`. É um instante UTC
 *   (`...Z`); a zona não é semanticamente relevante e o valor deve ser
 *   renderizado no fuso do dispositivo.
 * - **Hora-de-parede do evento** — `dataInicio`, `dataFim`, `inicioVendas`,
 *   `terminoVendas`, `dataInicioSessao`/`dataFimSessao`,
 *   `inicioCheckin`/`terminoCheckin`, `dataEvento`, `dataFimEvento`. Também
 *   viaja como instante UTC no fio, mas representa uma hora local num lugar:
 *   deve ser renderizada **no fuso do evento**.
 *
 * Cada campo diz a qual dos dois pertence, na própria `description`.
 *
 * Todo recurso que carrega hora-de-parede expõe um campo `timezone` (IANA,
 * ex.: `America/Sao_Paulo`) — inclusive os que apenas desnormalizam a data de
 * um evento (ingresso, transferência, repasse), justamente para o cliente
 * nunca precisar buscar o evento só para saber em que fuso renderizar.
 *
 * **Renderizar hora-de-parede no fuso do dispositivo, ou com offset chumbado
 * (`-0300`), é incorreto**: quebra em horário de verão e em qualquer evento
 * fora do Brasil. Cada cliente usa sua ferramenta nativa
 * (`Temporal.ZonedDateTime` no web, `package:timezone` no Flutter) — o padrão
 * compartilhado é o contrato, não a biblioteca.
 *
 * Nas **requisições**, todo valor `format: date-time` (corpo ou query param)
 * deve carregar offset explícito ISO-8601 — `Z` ou `±hh:mm`. Não existe fuso
 * implícito de servidor: omitir o offset é erro do cliente. Já `format: date`
 * (ex.: `dataNascimento`) é data de calendário, sem hora e sem fuso — a regra
 * não se aplica.
 *
 * Duas exceções de compatibilidade Sympla em `GET /api/v3/eventos`, ambas
 * fora da convenção acima: os params `from`/`to` usam o formato Sympla
 * `YYYY-MM-DD[ HH:mm:ss]` interpretado em UTC e **não** aceitam offset; e o
 * param `timezone` daquela rota é filtro de compatibilidade — **não** é o
 * fuso do evento.
 *
 * ## Retrocompatibilidade
 *
 * Os paths `/api/v1/...` e `/api/v2/...` permanecem funcionais com seu próprio
 * envelope `RestObject`. A v3 diverge deliberadamente dessa simetria (ver ADR
 * de modelagem de resposta v3): é superfície nova, contract-first, gerada.
 * Os clients gerados apontam para `/api/v3/...`.
 *
 * OpenAPI spec version: 3.8.0
 */

export type CheckinPayloadTipo = typeof CheckinPayloadTipo[keyof typeof CheckinPayloadTipo];


export const CheckinPayloadTipo = {
  QRCODE: 'QRCODE',
  CODIGO: 'CODIGO',
  FACIAL: 'FACIAL',
} as const;
